
export const ease = {
  linear: (x) => {
    return x;
  },
  in: {
    sine: (x) => {
      return 1 - Math.cos((x * Math.PI) / 2);
    },
    quad: (x) => {
      return x * x;
    },
    cubic: (x) => {
      return x * x * x;
    },
    quart: (x) => {
      return x * x * x * x;
    },
    quint: (x) => {
      return x * x * x * x * x;
    },
    expo: (x) => {
      return x === 0 ? 0 : Math.pow(2, 10 * x - 10);
    },
    circ: (x) => {
      return 1 - Math.sqrt(1 - Math.pow(x, 2));
    },
    back: (x) => {
      const c1 = 1.70158;
      const c3 = c1 + 1;
      return c3 * x * x * x - c1 * x * x;
    },
    elastic: (x) => {
      const c4 = (2 * Math.PI) / 3;
      return x === 0
        ? 0
        : x === 1
          ? 1
          : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * c4);
    },
    bounce: (x) => {
      return 1 - ease.out.bounce(1 - x);
    },
  },
  out: {
    sine: (x) => {
      return Math.sin((x * Math.PI) / 2);
    },
    quad: (x) => {
      return 1 - (1 - x) * (1 - x);
    },
    cubic: (x) => {
      return 1 - Math.pow(1 - x, 3);
    },
    quart: (x) => {
      return 1 - Math.pow(1 - x, 4);
    },
    quint: (x) => {
      return 1 - Math.pow(1 - x, 5);
    },
    expo: (x) => {
      return x === 1 ? 1 : 1 - Math.pow(2, -10 * x);
    },
    circ: (x) => {
      return Math.sqrt(1 - Math.pow(x - 1, 2));
    },
    back: (x) => {
      const c1 = 1.70158;
      const c3 = c1 + 1;
      return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2);
    },
    elastic: (x) => {
      const c4 = (2 * Math.PI) / 3;
      return x === 0
        ? 0
        : x === 1
          ? 1
          : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * c4) + 1;
    },
    bounce: (x) => {
      const n1 = 7.5625;
      const d1 = 2.75;
      if (x < 1 / d1) {
        return n1 * x * x;
      } else if (x < 2 / d1) {
        return n1 * (x -= 1.5 / d1) * x + 0.75;
      } else if (x < 2.5 / d1) {
        return n1 * (x -= 2.25 / d1) * x + 0.9375;
      } else {
        return n1 * (x -= 2.625 / d1) * x + 0.984375;
      }
    },
  },
  inout: {
    sine: (x) => {
      return -(Math.cos(Math.PI * x) - 1) / 2;
    },
    quad: (x) => {
      return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
    },
    cubic: (x) => {
      return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
    },
    quart: (x) => {
      return x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2;
    },
    quint: (x) => {
      return x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2;
    },
    expo: (x) => {
      return x === 0
        ? 0
        : x === 1
          ? 1
          : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2
            : (2 - Math.pow(2, -20 * x + 10)) / 2;
    },
    circ: (x) => {
      return x < 0.5
        ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2
        : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2;
    },
    back: (x) => {
      const c1 = 1.70158;
      const c2 = c1 * 1.525;
      return x < 0.5
        ? (Math.pow(2 * x, 2) * ((c2 + 1) * 2 * x - c2)) / 2
        : (Math.pow(2 * x - 2, 2) * ((c2 + 1) * (x * 2 - 2) + c2) + 2) / 2;
    },
    elastic: (x) => {
      const c5 = (2 * Math.PI) / 4.5;
      return x === 0
        ? 0
        : x === 1
          ? 1
          : x < 0.5
            ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * c5)) / 2
            : (Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * c5)) / 2 + 1;
    },
    bounce: (x) => {
      return x < 0.5
        ? (1 - ease.out.bounce(1 - 2 * x)) / 2
        : (1 + ease.out.bounce(2 * x - 1)) / 2;
    },
  }
};

export const $$ = {
  startTime: null,
  breakpoint1: 480,
  breakpoint2: 768,
};

Math.exRound = (num, decimalPoint = 1) => {
  const ratio = Math.pow(10, decimalPoint);
  num = num * ratio;
  num = Math.round(num);
  num = num / ratio;
  return num;
};

export function debug(values = {}, msg = null) {
  const isDebugMode = location.search.match(/(\?|\&)debug=1/) || false;
  if (!isDebugMode) return;
  if (values !== null) {
    if (typeof values !== "object") values = { values };
    const entries = Object.entries(values);
    [...entries].map((entry) => {
      const now = new Date();
      const hour = now.getHours();
      const min = now.getMinutes();
      const sec = now.getSeconds();
      const ms = now.getMilliseconds();

      msg = msg || `{${typeof entry[1]}} ${entry[0]}`;
      console.log(`::: ${msg} [${hour}:${min}:${sec}.${ms}]`);
      console.log(entry[1]);
      console.log('::::::::::::::::::::');
    });
  } else {
    console.log(`::: ${msg} [${hour}:${min}:${sec}.${ms}]`);
    console.log(values);
    console.log('::::::::::::::::::::');
  }
}

export function animate(doSomething, duration = 1000, easing = ease.out.cubic, callback = null) {
  const e = {};
  return new Promise((res, rej) => {
    let startTime = Date.now();

    const run = () => {
      let nowTime = Date.now();
      let elapsed = (duration - (nowTime - startTime) > 0) ? (nowTime - startTime) : duration;
      e.progress = Math.exRound(easing(elapsed / duration), 4);
      // e.progress = easing(elapsed / duration);

      if (elapsed !== duration) {
        doSomething(e);
        requestAnimationFrame(run);
      } else {
        elapsed = 1;
        doSomething(e);
        startTime = null;
        if (callback) callback();
        res();
      }
    }
    requestAnimationFrame(run);
  });
}

export function offset(elem) {
  if(!elem) return;
  const result = {};
  let rect = elem.getBoundingClientRect();

  result.top = rect.top + window.scrollY;
  result.left = rect.left + window.scrollX;
  result.right = rect.left + window.scrollX + elem.clientWidth;
  result.bottom = rect.top + window.scrollY + elem.clientHeight;

  return result;
}

export function scrollAddClass(selector = '.js-scroll-add-class', args = {}) {
  const _default = {
    startDelay: 0.25,
    mode: 'default'
  };

  let allElem = document.querySelectorAll(selector);
  const settings = { ..._default, ...args };

  [...allElem].map((elem, i) => {
    let offsetTop = elem.getBoundingClientRect().top + window.scrollY;
    const startDelay = elem.dataset.startDelay || settings.startDelay;
    if ((window.scrollY + window.innerHeight) - (window.innerHeight * startDelay) >= offsetTop) {
      if (!elem.classList.contains('is-animated')) {
        elem.classList.add('is-animated');
        elem.dispatchEvent(new Event('classAdded'));
      }
    } else {
      if (settings.mode === 'alternate') elem.classList.remove('is-animated');
    }
  });
}

export function generateRandomNum(max, min = -max, decimalPoint = 0) {
  return (Math.random() * (max - min) + min).toFixed(decimalPoint);
}

export async function smoothScroll(target, duration = 1000, easing = ease.out.cubic, callback) {
  let startPos = document.documentElement.scrollTop || document.body.scrollTop;
  let distance = target - startPos;
  let position = 0;

  await animate((e) => {
    position = startPos + (distance * easing(e.progress));
    window.scrollTo(0, position);
  }, duration, easing, callback);
}

export function getHeight(elem) {
  let clone = elem.cloneNode(true);
  elem.parentNode.appendChild(clone);
  const cssText = (clone.style.display === "none") ? "display: block; height:auto; visibility:hidden;" : "height:auto; visibility:hidden;";
  clone.style.cssText = "height:auto; visibility:hidden;";
  let cloneHeight = clone.offsetHeight;
  elem.parentNode.removeChild(clone);

  return cloneHeight;
}

export function zeroPadding(num, length) {
  return (Array(length).join('0') + num).slice(-length);
}

export function createElement(tagName = 'div', attributes = null) {
  let newEl = document.createElement(tagName);
  if (attributes) {
    for (const [key, val] of Object.entries(attributes)) {
      newEl.setAttribute(key, val);
    }
  }
  return newEl;
}

export function pushState(args = {}) {
  var title, path;
  if (!args) return;

  if (args.value) {
    title = `${args.value}`;
    path = location.pathname + `?pid=${args.value}`;
    history.pushState(title, null, path);
  } else {
    title = `index`;
    path = location.pathname;
    history.pushState(title, '', path);
  }

  if (args.id) {
    if (typeof gtag == "undefined") return;
    gtag('config', args.id, { 'page_path': location.pathname + location.search });
  }

  debug('PushStateを実行');
};

export function isDevice(type) {
  const isPC = window.matchMedia(`(min-width: ${$$.breakpoint2 + 1}px)`).matches;
  const isTB = window.matchMedia(`(min-width: ${$$.breakpoint1 + 1}px) and (max-width: ${$$.breakpoint2}px)`).matches;
  const isSP = window.matchMedia(`(max-width: ${$$.breakpoint1}px)`).matches;

  // console.log(isPC, isTB, isSP);
  // console.log(type);

  if (!type) {
    if (isPC) return 'PC';
    if (isTB) return 'TB';
    if (isSP) return 'SP';
  } else {
    if (type === 'PC') {
      return isPC;
    } else if (type === 'TB') {
      return isTB;
    } else if (type === 'SP') {
      return isSP;
    }
  }
}

export function getCustomProperty(_selector = document.documentElement, _property, removeExtension = false) {
  const element = (typeof _selector === 'object') ? _selector : document.querySelector(_selector);
  const style = getComputedStyle(element);
  let value = String(style.getPropertyValue(_property)).trim();
  if (removeExtension) value = parseInt(value);

  return value;
}

export function getCookie(keys = []) {
  if (!navigator.cookieEnabled) return;
  const result = {};

  if (document.cookie != '') {
    const tmp = document.cookie.split('; ');
    for (let i = 0; i < tmp.length; i++) {
      const data = tmp[i].split('=');
      result[data[0]] = decodeURIComponent(data[1]);
    }
  }
  return result;
}

export function arrayShuffle(array = []) {
  let obj = {};

  for (let i = 0; i < array.length; i++) {
    let rand = Math.floor(Math.random() * array.length + 1);
    if (!obj[rand]) {
      obj[rand] = array[i];
    } else {
      i--;
    }
  }
  return Object.values(obj);
}

export function clamp(num, min = 0, max = 1) {
  return Math.min(Math.max(num, min), max) || 0;
}

export function getFormatedDate(
  _format = 'YYYY/MM/DD hh:mm:ss:iii',
  _date = new Date()
) {
  const formatAry = _format.split(/[^a-zA-Z]/);
  const templates = [
    [/[Yy]/, _date.getFullYear()],
    [/[M]/, _date.getMonth() + 1],
    [/[Dd]/, _date.getDate()],
    [/[Hh]/, _date.getHours()],
    [/[m]/, _date.getMinutes()],
    [/[s]/, _date.getSeconds()],
    [/[i]/, _date.getMilliseconds()]
  ];

  return templates.reduce((accumulator, current, i, array) => {
    const currentFormat = formatAry[i];
    if (currentFormat && currentFormat.match(current[0])) {
      let str = current[1].toString();

      try {
        if (!currentFormat.match(/[YyMmDdHhsi]/)) new Error('予期しないテンプレート文字列が含まれています')
      } catch (e) {
        console.log(e.message);
      }
      if (currentFormat.match(/[Yy]/) && currentFormat.length == 2) {
        str = str.slice(-2);
      }
      accumulator = accumulator.replace(currentFormat, str.padStart(currentFormat.length, '0'))
    }
    return accumulator
  }, _format);
}